/** Quote a resolved value without introducing tokens into a formula expression. */
export const toFormulaStringLiteral = (value: string): string => {
  const escaped = JSON.stringify(value).slice(1, -1).replaceAll("'", '\\u0027')
  return `'${escaped}'`
}
